import React from 'react';
import errorImg from '../images/404-page-not-found.svg';
const ErrorScreen = () => {
  return <img src={errorImg} alt="404" />;
};

export default ErrorScreen;
